'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _baseForm = require('common/components/base-form');

var _baseForm2 = _interopRequireDefault(_baseForm);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

var _googleLoginOrSignup = require('./google-login-or-signup');

var _googleLoginOrSignup2 = _interopRequireDefault(_googleLoginOrSignup);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _setTimeout = require('common/utils/set-timeout');

var _setTimeout2 = _interopRequireDefault(_setTimeout);

var _loginTrigger = require('./login-trigger');

var _loginTrigger2 = _interopRequireDefault(_loginTrigger);

var _logger = require('common/logger');

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/* -----------  SIGNUP  ----------------------------------- */

/**
 * NOTE: This form does not follow the proper way to use
 * React and Symfony Forms, a better example can be found
 * by looking at ForgotPasswordForm
 */

function getDefaultGoogleOpenIdUrl() {
    // encode '/' endpoint -- we'd use btoa, except IE10 and below doesn't support it
    var redirectUrl = 'Lw==';
    return '/account/openid/connect/google?on_login_redirect_url=' + redirectUrl;
}

var CreateAccountForm = _baseForm2['default'].createFormClass({

    displayName: 'CreateAccountForm',

    propTypes: {
        'header': _react.PropTypes.string,
        'buttonText': _react.PropTypes.string,
        'isInline': _react.PropTypes.bool,
        'isVertical': _react.PropTypes.bool, // only works for inline
        'inlineSideText': _react.PropTypes.string,
        'googleOpenIdUrl': _react.PropTypes.string,
        'redirectUrl': _react.PropTypes.string,
        'isFromApiPricing': _react.PropTypes.bool,
        'planId': _react.PropTypes.string,
        'tabOffset': _react.PropTypes.number,
        'async': _react.PropTypes.bool,
        'recoverPasswordForm': _react.PropTypes.object, // Serialized sfForm
        'loginForm': _react.PropTypes.object, // Serialized sfForm
        'hideRememberMe': _react.PropTypes.bool,
        'hideGoogleOpenId': _react.PropTypes.bool
    },

    getDefaultProps: function getDefaultProps() {
        return {
            'async': true,
            'googleOpenIdUrl': getDefaultGoogleOpenIdUrl()
        };
    },
    getInitialState: function getInitialState() {
        return {
            'errors': this.props.errors,
            'emailAddress': '',
            'isProcessing': false,
            'isInline': false,
            'isVertical': false,
            'isOptedIn': true
        };
    },
    componentDidMount: function componentDidMount() {
        _logger2['default'].track('CreateAccountForm.componentDidMount', {
            location: location.pathname
        });

        if (!this.props.isInline) {
            // This is a modal, so focus on the email address input element
            (0, _setTimeout2['default'])(function () {
                $(_reactDom2['default'].findDOMNode(this)).find('input[name="signup[email_address]"]').focus();
            }.bind(this), 500);
        }
    },
    onEmailChange: function onEmailChange(event) {
        this.setState({
            'emailAddress': event.target.value.trim()
        });
    },
    onOptInChange: function onOptInChange(event) {
        this.setState({
            'isOptedIn': event.target.checked
        });
    },
    onSubmit: function onSubmit(evt) {
        evt.preventDefault();

        if (this.state.isProcessing === false) {

            // Retrieve the values from the email field one more time
            // prior to submit. This fixes an issue where Safari auto-complete
            // would not trigger the on*Change events for these fields.
            var root = _reactDom2['default'].findDOMNode(this);
            var emailAddress = $('#sign_up_email_address_input', root).val();

            this.setState({
                'errors': null,
                'isProcessing': true,
                'emailAddress': emailAddress
            });

            if (!_hfReactHelper2['default'].isValidEmailAddress(emailAddress)) {

                this.setState({
                    'errors': { 'named': { 'email_address': 'Invalid email address' } },
                    'isProcessing': false
                });
            } else if (!this.props.async) {
                _logger2['default'].track('CreateAccountForm._onSubmit');
                // Inline submit
                $('#sign_up_form', root).submit();
            } else {

                // Async submit
                this.submitAsync(function (resp) {

                    this.setState({
                        'isProcessing': false
                    });

                    // Display notification
                    if (resp.notification) {
                        hellofaxJS.createNotification({
                            'text': resp.notification.message,
                            'class_name': resp.notification.type
                        });
                    }

                    // Close the signup modal and show the login one
                    if (resp.show_login_form) {
                        $('.m-modal--close', '#create_account_modal').click();
                        $(document).trigger('login-trigger', { 'displayCaptcha': resp.display_captcha });
                        return;
                    }

                    // Redirect to redirect_url
                    if (resp.success === true) {
                        _logger2['default'].track('CreateAccountForm._onSubmit');
                        if (resp.redirect_url) {
                            document.location = resp.redirect_url;
                        }
                    }

                    // Failure
                    if (!resp.success) {

                        // Display error message
                        if (resp.error && !resp.notification_message) {
                            this.setState({
                                'errors': { 'global': resp.error.message }
                            });
                        }
                    }
                }, function () {

                    // Unexpected error
                    this.setState({
                        'errors': { 'global': 'An unexpected error occurred' },
                        'isProcessing': false
                    });
                });
            }
        }

        return false;
    },
    render: function render() {
        var isVertical = !this.props.isInline || this.props.isVertical; // is vertical (even if not inline)
        var tabOffset = parseInt(this.props.tabOffset || 0, 10);
        var rowClassNames = (0, _classnames2['default'])({
            'row': true,
            'text-center': true,
            'bg-plume': this.props.isInline ? true : false,
            'm-create-account--inline-container': this.props.isInline && !this.props.isVertical,
            'm-create-account--inline-container-vertical': this.props.isInline && this.props.isVertical,
            'l-padding-v-20': this.props.isInline ? true : false
        });

        var includeInlineText = function includeInlineText(text) {
            return _react2['default'].createElement(
                'div',
                { className: 'm-create-account--login-side-text columns small-12 large-4 l-margin-v-20 ' },
                _react2['default'].createElement(
                    'h2',
                    { className: 'c-ashen' },
                    text
                )
            );
        };

        var formColumnClassNames = (0, _classnames2['default'])({
            'text-left m-create-account--sign-up': !isVertical,
            'columns small-12 l-margin-v-20 text-center': true,
            'large-5 large-left': !isVertical
        });
        var buttonColumnClassNames = (0, _classnames2['default'])({
            'columns small-12 l-margin-v-20 text-center': true,
            'large-3 large-left': !isVertical,
            'm-create-account--inline-google-login': !isVertical,
            'm-create-account--modal-google-login': isVertical
        });
        var submitButtonClassNames = (0, _classnames2['default'])({
            'm-create-account--inline-create-account-button': !isVertical,
            'm-create-account--modal-create-account-button': isVertical
        });

        var redirectUrl;
        if (this.props.redirectUrl) {
            redirectUrl = _react2['default'].createElement('input', { type: 'hidden', name: 'signup[redirect_url]', value: this.props.redirectUrl });
        }

        var isFromApiPricing;
        if (this.props.isFromApiPricing) {
            isFromApiPricing = _react2['default'].createElement('input', { type: 'hidden', name: 'is_from_api_pricing', value: this.props.isFromApiPricing ? '1' : '' });
        }

        var planId;
        if (this.props.planId) {
            planId = _react2['default'].createElement('input', { type: 'hidden', name: 'plan_id', value: this.props.planId });
        }

        var errors;
        if (this.state.errors) {
            errors = _react2['default'].createElement(
                'div',
                { className: 'row' },
                _react2['default'].createElement(
                    'div',
                    { className: 'columns l-margin-b-10 small-10 small-offset-1 text-center m-modal--error' },
                    this.renderErrorText()
                )
            );
        }

        var buttonText = this.props.buttonText ? this.props.buttonText : 'SIGN UP FREE';
        if (this.state.isProcessing) {
            buttonText = 'PROCESSING...';
        }

        var loginUrl = _hfReactHelper2['default'].urlHelper('account/logIn');
        var loginTrigger, loginPrompt;
        if (this.props.loginForm) {
            var loginTrigger = _react2['default'].createElement(_loginTrigger2['default'], {
                linkText: 'Login',
                buttonText: 'Sign In',
                header: 'Welcome back',
                googleOpenIdUrl: this.props.googleOpenIdUrl,
                loginUrl: loginUrl,
                redirectUrl: this.props.redirectUrl,
                recoverPasswordForm: this.props.recoverPasswordForm,
                loginForm: this.props.loginForm,
                hideRememberMe: this.props.hideRememberMe,
                hideGoogleOpenId: this.props.hideGoogleOpenId });

            var loginPrompt = _react2['default'].createElement(
                'div',
                { className: 'columns small-12' },
                _react2['default'].createElement(
                    'div',
                    { className: 'm-create-account--login-prompt' },
                    'Already have an account? ',
                    loginTrigger
                )
            );
        }

        var googleOpenId;
        if (!this.props.hideGoogleOpenId) {
            var googleLoginImage = _react2['default'].createElement(
                'div',
                { className: !isVertical ? 'm-create-account--inline-google-login-border' : 'm-create-account--modal-google-login-border' },
                _react2['default'].createElement('div', { className: !isVertical ? 'm-create-account--inline-google-login-or-image' : 'm-create-account--modal-google-login-or-image' })
            );
            googleOpenId = _react2['default'].createElement(
                'div',
                { className: buttonColumnClassNames },
                this.props.fields ? googleLoginImage : null,
                _react2['default'].createElement(
                    'div',
                    { className: !isVertical ? 'm-create-account--inline-google-login-button' : 'm-create-account--modal-google-login-button' },
                    _react2['default'].createElement(_googleLoginOrSignup2['default'], {
                        openIdUrl: this.props.googleOpenIdUrl,
                        isOptedIn: this.state.isOptedIn,
                        isLogIn: false })
                )
            );
        }
        var signupForm = _react2['default'].createElement(
            'div',
            { className: formColumnClassNames },
            _react2['default'].createElement(
                'div',
                { className: 'small-10 small-offset-1 text-center' },
                this.renderField('email_address', {
                    'id': 'sign_up_email_address_input',
                    'className': 'm-create-account--text-input ' + (isVertical ? 'm-create-account--email-vertical' : ''),
                    'maxLength': '99',
                    'placeholder': 'Enter your email',
                    'onChange': this.onEmailChange,
                    'tabIndex': tabOffset,
                    'data-format': 'email'
                })
            ),
            _react2['default'].createElement(
                'div',
                { className: 'small-10 small-offset-1 small-text-left' },
                _react2['default'].createElement(
                    'div',
                    { className: 'm-create-account--opt-in-container' },
                    _react2['default'].createElement(
                        'div',
                        { className: 'm-create-account--opt-in-align' + (isVertical ? '-vertical' : '') },
                        _react2['default'].createElement(
                            'label',
                            null,
                            this.renderField('is_opted_in_marketing_emails', {
                                'className': 'm-create-account--text-input',
                                'defaultChecked': 'checked',
                                'tabIndex': tabOffset + 2,
                                'onChange': this.onOptInChange
                            }),
                            '\xA0Send me HelloSign updates'
                        )
                    )
                )
            ),
            errors,
            this.renderHiddenFields(),
            _react2['default'].createElement('input', { type: 'hidden', name: 'async', value: this.props.async ? '1' : '0' }),
            _react2['default'].createElement('input', { type: 'hidden', name: 'force_delay_analytics_js', value: 'true' }),
            _react2['default'].createElement(
                'div',
                { className: 'l-margin-b-10 small-10 small-offset-1 small-text-center ' + (!isVertical ? 'large-text-left' : '') },
                _react2['default'].createElement(_button2['default'], { onClick: this.onSubmit,
                    buttonClass: submitButtonClassNames,
                    buttonText: buttonText,
                    buttonColor: 'grasshopper',
                    buttonHoverColor: 'castle-rock',
                    buttonTabIndex: tabOffset + 3 })
            )
        );

        return _react2['default'].createElement(
            'div',
            { className: 'm-create-account' },
            _react2['default'].createElement(
                'form',
                { id: 'sign_up_form', className: 'm-create-account--form', action: this.props.action, method: 'POST' },
                _react2['default'].createElement(
                    'div',
                    { className: rowClassNames },
                    _react2['default'].createElement(
                        'div',
                        { className: 'columns small-12' },
                        _react2['default'].createElement(
                            'h4',
                            null,
                            this.props.header
                        )
                    ),
                    !isVertical ? includeInlineText(this.props.inlineSideText) : '',
                    googleOpenId,
                    this.props.fields ? signupForm : null,
                    isVertical && this.props.loginForm ? loginPrompt : ''
                ),
                redirectUrl,
                isFromApiPricing,
                planId
            )
        );
    }
});

module.exports = CreateAccountForm;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/auth/create-account-form.jsx
 ** module id = 873
 ** module chunks = 0
 **/